// extracted by mini-css-extract-plugin
export var button = "_17-1";
export var featuredLink = "_17-4";
export var spinner = "_17-2";
export var spinnerContainer = "_17-3";
export var text = "_17-0";